
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"auto","height":"auto","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.833 6.667A4.171 4.171 0 0110 2.5a4.171 4.171 0 014.167 4.167A4.171 4.171 0 0110 10.833a4.171 4.171 0 01-4.167-4.166zm1.667 0c0 1.378 1.122 2.5 2.5 2.5s2.5-1.122 2.5-2.5h-5z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M7.567 11.967c-2.577.668-4.234 2.414-4.234 4.7v1.666h5.648l-1.414-6.366zM12.433 11.967l-1.414 6.366h5.648v-1.666c0-2.286-1.657-4.032-4.234-4.7zM9.167 14.167l.833-2.5.833 2.5L10 17.5l-.833-3.333z","fill":"currentColor"}})])
          )
        }
      }
    